<template>
  <div class="relative w-full">
    <span v-if="label" class="absolute -top-2 left-2 bg-white px-1 text-xs text-gray-500 !z-1">{{ label }}</span>
    <Combobox
      :model-value="modelValue"
      @update:modelValue="onSelect"
    >
      <div class="relative">
        <div class="relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left focus:outline-none sm:text-sm">
          <ComboboxInput
            class="w-full basicInput !pr-10"
            :display-value="displayValue"
            :placeholder="placeholder"
            :required="required"
            :disabled="disabled"
            @input="onInput"
            @change="onChange"
          />
          <ComboboxButton class="absolute inset-y-0 right-0 flex items-center !m-1 !h-7 rounded-2xl" :disabled="disabled">
            <i class="fas fa-chevron-down"></i>
          </ComboboxButton>
        </div>
        <TransitionRoot
          leave="transition ease-in duration-100"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <ComboboxOptions
            class="absolute z-2 max-h-60 w-full overflow-auto rounded-xl bg-white shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm"
          >
            <ComboboxOption
              v-if="allowEmpty"
              :value="null"
              as="template"
              v-slot="{ selected, active }"
            >
              <li
                class="relative cursor-pointer select-none p-2 pr-3"
                :class="{
                  'bg-primary text-white': active,
                  'text-gray-900': !active,
                }"
              >
                <span class="block truncate" :class="{ 'font-medium': selected, 'font-normal': !selected }">
                  {{ emptyLabel }}
                </span>
              </li>
            </ComboboxOption>
            <ComboboxOption
              v-for="option in filteredOptions"
              :key="option.value"
              :value="option.value"
              as="template"
              v-slot="{ selected, active }"
            >
              <li
                class="relative cursor-pointer select-none p-2 pr-3 text-left"
                :class="{
                  'bg-primary text-white': active,
                  'text-gray-900': !active,
                }"
              >
                <span class="block truncate" :class="{ 'font-medium': selected, 'font-normal': !selected }">
                  {{ option.label }}
                </span>
              </li>
            </ComboboxOption>
            <ComboboxOption
              v-if="showAddOption"
              value="__add__"
              as="template"
              v-slot="{ active }"
            >
              <li
                class="relative cursor-pointer select-none p-2 pr-3 font-bold"
                :class="{
                  'bg-primary text-white': active,
                  'text-gray-900': !active,
                }"
                @click="onAddNew"
              >
                <span class="block truncate">
                  {{ addOptionLabel }}
                </span>
              </li>
            </ComboboxOption>
          </ComboboxOptions>
        </TransitionRoot>
      </div>
    </Combobox>
  </div>
</template>

<script>
import {
  Combobox,
  ComboboxInput,
  ComboboxButton,
  ComboboxOptions,
  ComboboxOption,
  TransitionRoot,
} from '@headlessui/vue'

export default {
  name: 'SelectCombobox',
  components: {
    Combobox,
    ComboboxInput,
    ComboboxButton,
    ComboboxOptions,
    ComboboxOption,
    TransitionRoot,
  },
  props: {
    modelValue: { type: [String, Number, null], default: null },
    options: { type: Array, required: true }, // [{ value, label }]
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    required: { type: Boolean, default: false },
    allowEmpty: { type: Boolean, default: true },
    emptyLabel: { type: String, default: 'Aucun' },
    displayValue: { type: Function, default: (val) => val },
    showAddOption: { type: Boolean, default: false },
    addOptionLabel: { type: String, default: 'Ajouter un client' },
    disabled: { type: Boolean, default: false },
  },
  emits: ['update:modelValue', 'select', 'add-new'],
  data() {
    return {
      query: '',
      internalValue: this.modelValue,
    };
  },
  computed: {
    filteredOptions() {
      if (!this.query) return this.options;
      return this.options.filter(option =>
        option.label.toLowerCase().replace(/\s+/g, '').includes(this.query.toLowerCase().replace(/\s+/g, ''))
      );
    },
  },
  methods: {
    onInput(e) {
      console.log('Input changed:', e.target.value);
      this.query = e.target.value;
    },
    onSelect(value) {
      console.log('Selected value:', value);
      if (value === '__add__') {
        this.onAddNew();
        return; // Ne rien faire ici, géré par @add-new
      }
      this.internalValue = value;
      this.$emit('update:modelValue', value);
      this.$emit('select', value);
      this.query = '';
    },
    onChange() {
      console.log('Change event triggered with query:', this.query);
      // Si la saisie ne correspond à aucune option, on vide
      const match = this.options.find(
        option => option.label.toLowerCase().replace(/\s+/g, '') === this.query.toLowerCase().replace(/\s+/g, '')
      );
      if (match) {
        this.onSelect(match.value);
      } else {
        this.internalValue = null;
        this.$emit('update:modelValue', null);
        this.$emit('select', null);
      }
      this.query = '';
    },
    onAddNew() {
      console.log('Adding new option:', this.query);
      this.onSelect(this.query);
      this.$emit('add-new', this.query);
    },
  },
  watch: {
    modelValue(val) {
      this.internalValue = val;
      // Met à jour la query pour afficher le label correspondant
      const match = this.options.find(option => option.value === val);
      // this.query = match ? match.label : '';
    },
    query(newQuery) {
      console.log('Query updated:', newQuery);
    },
  },
};
</script>